import {defineSlotRecipe} from '@chakra-ui/react3'

export const productAvailabilityRecipe = defineSlotRecipe({
    slots: ['container', 'text'],
    base: {
        container: {
            display: 'inline-flex',
            px: '6px',
            py: '0px',
            gap: '4px',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '4px',
            height: '18px'
        },
        text: {
            textStyle: 'body.xsmall'
        }
    },
    variants: {
        status: {
            instock: {
                container: {
                    bg: 'background.system.success-light',
                    color: 'text.system.success-on-surface'
                }
            },
            lowstock: {
                container: {
                    bg: 'background.system.warning-light',
                    color: 'text.on-media.brand'
                }
            },
            outofstock: {
                container: {
                    bg: 'background.system.error-light',
                    color: 'background.system.error-strong'
                },
                text: {
                    color: 'text.system.error-on-surface'
                }
            },
            comingsoon: {
                container: {
                    bg: 'background.brand.light',
                    color: 'text.on-media.brand'
                }
            },
            discontinued: {
                container: {
                    bg: 'background.actions.tertiary-active',
                    color: 'text.secondary'
                }
            }
        }
    }
})
